// 📄 components/StepAPSiteConfig.tsx
import React from 'react';
import { GeneralsFormData } from '../../../../../services/commerce/integrationService.ts';

interface StepAPSiteConfigProps {
  apRealmId: string;
  apIntegrationDir: string;
  onChange: (field: keyof GeneralsFormData, value: any) => void;
  isInvalid: boolean;
}

export function StepAPSiteConfig({
  apRealmId,
  apIntegrationDir,
  onChange,
  isInvalid
}: StepAPSiteConfigProps) {
  return (
    <div className="space-y-4 animate-fadeIn">
      <div className="bg-amber-500/5 border border-amber-500/10 rounded-xl p-3 space-y-1">
        <span className="text-[10px] font-bold text-amber-400 uppercase tracking-widest block">SAP Ariba Buyer Portal</span>
        <p className="font-mono text-xs text-gray-300">
          <span>Ariba Administrator → Core Administration → Integration Manager → Site Integration Parameters</span>
        </p>
      </div>

      <div>
        <h3 className="text-lg font-medium text-amber-400">1. Parámetros del Sitio Ariba (Realm ID)</h3>
        <p className="text-sm text-gray-400 mt-1">
          Configura y vincula el Realm ID único y el Directorio de Integración del Ariba Buyer Portal. 
          Esto permite el mapeo seguro de identidades y endpoints del lado de Ariba.
        </p>
      </div>

      <div className="bg-white/5 p-4 rounded-xl border border-white/5 grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-xs font-medium text-gray-400 mb-1">
            SAP Ariba Realm ID <span className="text-red-400">*</span>
          </label>
          <input
            type="text"
            value={apRealmId}
            onChange={(e) => onChange('apRealmId', e.target.value)}
            placeholder="ej. miempresa-T o AN010002345"
            className={`w-full bg-zinc-800 border rounded-lg p-2.5 text-sm font-mono text-white focus:outline-none focus:border-amber-500 ${
              isInvalid && !apRealmId ? 'border-red-500' : 'border-white/10'
            }`}
          />
        </div>

        <div>
          <label className="block text-xs font-medium text-gray-400 mb-1">
            Integration Directory Path <span className="text-red-400">*</span>
          </label>
          <input
            type="text"
            value={apIntegrationDir}
            onChange={(e) => onChange('apIntegrationDir', e.target.value)}
            placeholder="ej. /ariba/buyer/integration/directory"
            className={`w-full bg-zinc-800 border rounded-lg p-2.5 text-sm font-mono text-white focus:outline-none focus:border-amber-500 ${
              isInvalid && !apIntegrationDir ? 'border-red-500' : 'border-white/10'
            }`}
          />
        </div>
      </div>
    </div>
  );
}
